
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.574 5.574a.837.837 0 011.181 0 .832.832 0 010 1.179L8 11.497 3.245 6.753a.832.832 0 010-1.179.837.837 0 011.18 0L8 9.14l3.574-3.566z","fill":"#008CE1","fill-rule":"evenodd"}})])
          )
        }
      }
    